import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../api/apiClient'; // Import the axios instance

// Create an async thunk to fetch products from the API
export const fetchProducts = createAsyncThunk('products/fetchProducts', async () => {
    try {
        const response = await apiClient.get('/products');  // Adjust your API endpoint if necessary
        return response.data;  // Return product data from the API response
    } catch (error) {
        throw error;  // Handle error if the API request fails
    }
});

// Create the slice
const productSlice = createSlice({
    name: 'products',
    initialState: {
        products: {
            products: [] // Nested products array to match the component's expectations
        },
        status: 'idle',  // idle | loading | succeeded | failed
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.status = 'succeeded';
                // Handle both possible API response formats
                if (action.payload && Array.isArray(action.payload)) {
                    // If the API returns an array directly
                    state.products = { products: action.payload };
                } else if (action.payload && action.payload.products) {
                    // If the API returns an object with a products property
                    state.products = action.payload;
                } else {
                    // Fallback for unexpected response format
                    state.products = { products: [] };
                }
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    },
});

// Export the action and reducer
export default productSlice.reducer;